export const STATUSCHANGED = "filters/statusChanged";
export const SEARCHFILTER = "filters/searchFilter";
